module.exports = __webpack_public_path__ + "static/media/speaker_HKSTP_Crystal.096cbd50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_HKSTP_Crystal.jpg
// module id = 245
// module chunks = 0